import { Machine } from './machine';
import { Department } from './department';
import { Preference } from './preference';

export class Article {
  public sku: string; // codigo de barras
  public name: string;
  public unitPrice: number; // precio de Venta sin impuesto
  public description?: string;
  public priceCost?: number;
  public unitInStock?: number;
  public supplierId?: string;
  public departmentId?: number;
  public departamentName?: string;
  public cantToOrder?: string;
  public itemFarmacia?: itemPharmacy;
  public unitPrice2?: number;
  public unitPrice3?: number;
  public unitPrice4?: number;
  public unitPrice5?: number;
  public itemAvailable: boolean;
  public profitMargin1?: number;
  public profitMargin2?: number;
  public profitMargin3?: number;
  public profitMargin4?: number;
  public profitMargin5?: number;
  public itemIdCofarsurId?: number;
  public usarPrecioSugerido: boolean;
  public precioSugerido: number;
  public fractionated: boolean;
  public quantityPerUnit: number;
  public askPrice: boolean;
  public updatePriceType: number;
  public formatQuantityExisting: string;
  public model: string;
  public department: Department;
  public weight: boolean;
  public taxCode1: number;
  public machines: Machine[];
  public sizes: string[]; // talles
  public designs: string[]; // colores
  public photos: string;
  public photosToRemove: string[];
  public fromClient: boolean;
  public virtual: boolean;
  public linkedItems: string[];
  public linkedItemsCompleteList: Article[];
  public dolarCost: number;
  public priceCostFinal: number;
  discountpriceCost: number;
  extendedCode: number;
  marca: Preference;

  constructor() {
    this.sku = '';
    this.name = '';
    this.description = '';
    this.priceCost = 0;
    this.unitInStock = 0;
    this.supplierId = '0';
    this.departmentId = 0;
    this.departamentName = '';
    this.cantToOrder = '';
    this.itemFarmacia = new itemPharmacy();
    for (const n of [1, 2, 3, 4, 5]) {
      if (n === 1) {
        this['unitPrice'] = null;
        this['profitMargin' + n] = 0;
      } else {
        this['unitPrice' + n] = 0;
        this['profitMargin' + n] = 0;
      }
    }
    this.itemIdCofarsurId = 0;
    this.usarPrecioSugerido = false;
    this.itemAvailable = true;
    this.precioSugerido = null;
    this.fractionated = false;
    this.quantityPerUnit = 0;
    this.askPrice = false;
    this.updatePriceType = null;
    this.formatQuantityExisting = '';
    this.model = '';
    this.department = {
      id: null,
      fatherId: null,
      name: null,
      specialType: null,
      complexCode: null,
      text: null,
      children: [],
    };
    this.weight = false;
    this.taxCode1 = null;
    this.machines = null;
    this.sizes = [];
    this.designs = [];
    this.photos = null;
    this.photosToRemove = [];
    this.fromClient = false;
    this.virtual = false;
    this.linkedItems = [];
    this.linkedItemsCompleteList = [];
    this.dolarCost = 0;
    this.priceCostFinal = 0;
    this.discountpriceCost = 0;
    this.extendedCode = 0;
    this.marca = new Preference(0, null, null, null, null);
  }
}

// tslint:disable-next-line:class-name
export class itemPharmacy {
  public troquel: string;
  public tamanosId: string;
  public accioFarId: string;
  public monoDroId: string;
  public formasId: string;
  public uPotenciId: string;
  public tipoUnidId: string;
  public viasId: string;
  public laboratorio: string;
  public controlado: string;
  public importado: boolean;
  public tipoVenta: string;
  public iva: boolean;
  public codigoDescuentoPami: string;
  public codigoLaboratorio: string;
  public nroRegistroAlfaBeta: string;
  public heladera: boolean;
  public sifar: boolean;
  public gravamen: boolean;
  public baja: boolean;
  public linkedItems: string[];
  public virtual: boolean;

  constructor() {
    this.troquel = null;
    this.tamanosId = null;
    this.accioFarId = null;
    this.monoDroId = null;
    this.formasId = null;
    this.uPotenciId = null;
    this.tipoUnidId = null;
    this.viasId = null;
    this.laboratorio = null;
    this.controlado = null;
    this.importado = null;
    this.tipoVenta = null;
    this.iva = null;
    this.codigoDescuentoPami = null;
    this.codigoLaboratorio = null;
    this.nroRegistroAlfaBeta = null;
    this.heladera = null;
    this.sifar = null;
    this.gravamen = null;
    this.baja = null;
    this.linkedItems = null;
    this.virtual = null;
  }
}

export class ArticleFilter {
  public page: number;
  public articleFind: string;
  public supplierId: number;
  public onlyEnabledToFind: boolean;
  public virtual: boolean;

  constructor() {
    this.page = 1;
    this.articleFind = '';
    this.supplierId = 0;
    this.onlyEnabledToFind = true;
    this.virtual = false;
  }
}

export interface ExtendedField {
  key: string;
  value: string;
}

export class ArticleExcel {
  public codigoBarras: string;
  public nombre: string;
  public descripcion: string;
  public precio: string;

  constructor(
    codigoBarras: string,
    nombre: string,
    descripcion: string,
    precio: string
  ) {
    this.codigoBarras = codigoBarras;
    this.nombre = nombre;
    this.descripcion = descripcion;
    this.precio = precio;
  }
}

export interface Iarticle {
  article: Article;
}

export class UpdatePriceFilter {
  departamentId: number;
  supplierId: number;
  article: string;
  percentToUpPrice: number;
  priceList = {
    price1: false,
    price2: false,
    price3: false,
    price4: false,
    price5: false
  };

  constructor() {
    this.departamentId = 0;
    this.supplierId = 0;
    this.percentToUpPrice = null;
    this.article = null;
    this.clearprices();
  }

  clearprices = () => {
    for (const key of Object.keys(this.priceList)) {
      this.priceList[key] = false;
    }
  }
}

export class UpdatePriceArticle {
  departamentId: number;
  supplierId: number;
  article: string;
  percentToUpPrice: number;
  price1: boolean;
  price2: boolean;
  price3: boolean;
  price4: boolean;
  price5: boolean;

  constructor(filter: UpdatePriceFilter) {
    this.departamentId = filter.departamentId;
    this.supplierId = filter.supplierId;
    this.article = filter.article;
    this.percentToUpPrice = filter.percentToUpPrice;
    this.price1 = filter.priceList.price1;
    this.price2 = filter.priceList.price2;
    this.price3 = filter.priceList.price3;
    this.price4 = filter.priceList.price4;
    this.price5 = filter.priceList.price5;
  }
}

export interface FilterContainer {
  article: Article;
  departmentId: number;
  page: number;
}
